import { PropsWithChildren } from 'react';
import { Tab } from '@headlessui/react';

export const TabList = ({ children }: PropsWithChildren) => (
  <Tab.List className='my-2 flex gap-7 border-b-2 border-neutral-200 outline-none'>
    {children}
  </Tab.List>
);
